// TODO FILE IS DEPERECATED (?)

const TYPE_JSON = ['application/json']
const TYPE_IMAGE = ['image/png', 'image/jpeg']
const ALLOWED_TYPES = TYPE_JSON.concat(TYPE_IMAGE);

// TODO GIVE CREDIT FOR 'handleUpload' AND 'readUploadedFileAsText' OR REWRITE
const readUploadedFile = (inputFile, type) => {
    const temporaryFileReader = new FileReader();

    return new Promise((resolve, reject) => {
        temporaryFileReader.onerror = () => {
            temporaryFileReader.abort();
            reject(new DOMException("Problem parsing input file."));
        };

        
        // TODO TYPE STRONGER!
        
        if (type === 'json') {
            console.log('READING JSON');
            temporaryFileReader.onload = () => {
                resolve(temporaryFileReader.result);
            };
            temporaryFileReader.readAsText(inputFile);
        } else if (type === 'image') {
            console.log('READING IMAGE');
            temporaryFileReader.onload = () => {
                var image = new Image();
                image.height = 100;
                image.title = temporaryFileReader.name;
                image.src = temporaryFileReader.result;
                resolve(image);
            };
            temporaryFileReader.readAsDataURL(inputFile);
        } else {
            console.error('SOMETHING WORNG!: ' + type );
            
        }
    });
};

const handleUpload = async (file, type) => {
    try {
        const fileContents = await readUploadedFile(file, type)
        return fileContents
    } catch (e) {
        console.warn(e.message)
    }
}


class ProcessFileHandler {

    file = null;

    constructor(file) {
        this.file = file;
    }

    async getContents(file = this.file) {
        const type = file.type;
        if (!file || !ALLOWED_TYPES.includes(type)) {
            console.error('No file or Invalid filetype: ' + type);
            return null;
        }
        if (TYPE_JSON.includes(type)) {
            const content = await this._getJsonContent(file)
            return {
                type: TYPE_JSON,
                content: content
            }
        }
        if (TYPE_IMAGE.includes(type)) {
            const image = await this._getImageContent(file);
            return {
                type: TYPE_IMAGE,
                content: image
            }
            console.log(image);
        }
        console.error('Scripts should not have run this far')
        return null
    }

    async _getJsonContent(file) {
        const fileContent = await handleUpload(file, 'json');
        const process = JSON.parse(fileContent)
        if (!this._isValidProcess(process)) {
            console.error('Uploaded JSON is not valid process');
            return null;
        }
        process['title'] = file.name;
        return process;
    }

    async _getImageContent(file) {
        const fileContent = await handleUpload(file, 'image');
        // const image = JSON.parse(fileContent)
        return fileContent;
    }

    _isValidProcess(process) {
        // TODO WRITE PROPER FILE VALIDATION! HERE WOULD TYPESCRIPT BE NICE
        return true;
    }
}

export { ProcessFileHandler };